import { Injectable } from '@angular/core'
import { PaginationModel } from '@spartacus/core'

export interface InitialPaginationModel extends PaginationModel {
  pageSize: number;
  currentPage: number;
}
@Injectable({
  providedIn: 'root'
})
export abstract class MpupPaginationService {

  protected constructor () {
  }

  isOnCurrentPage (index: number, pagination: PaginationModel): boolean {
    if (pagination.currentPage !== undefined && pagination.pageSize !== undefined) {
      return (index >= (pagination.currentPage * pagination.pageSize)) &&
        (index < ((pagination.currentPage + 1) * pagination.pageSize))
    }
    return false
  }

  pageEntries<T> (entries: ReadonlyArray<T>, pagination: PaginationModel): ReadonlyArray<T> {
    return entries.filter((item, index) => this.isOnCurrentPage(index, pagination))
  }
}
